import {
    FullMatchElement,
    MatchElement,
    ValidationDetail,
    ValidationTableDef,
    ValidationTableFlow,
    ValidationTableMatchResult,
    Dictionary,
    CoinValue,
    ExchangeValue,
    ValidationSelectOption,
    generalTransactionTypes,
    GeneralTransactionType,
    ValidationEditItem,
    ValidationTableTransaction,
  } from 'models/validation';
import MaterialReactTable, {
  type MRT_ColumnFiltersState,
  type MRT_RowSelectionState,
} from 'material-react-table';
import axios from 'axios';
import { postMainAppApiData } from './api';
import { PillModifier } from 'components/pill';
import { TableDataRes } from 'components/table/base/tableBaseApi';
import dayjs from 'dayjs';
  
  export const isTrade = (value: ValidationTableDef): boolean => {
    if (value && value.transaction && value.transaction.id) { // is defined
      if ((value.transaction.transaction_type === 2 || value.transaction.transaction_type === 1)
        && value.matched_transaction !== null
        && (value.transaction.matched_transaction_id !== null)
      ) {
      // is already matched and is a trade
        return true;
      }
    }

    return false;
  };

export const getAccountBalance = (
    accountBalance: ValidationTableFlow[],
    value: ValidationTableDef,
  ): string => {
    if (isTrade(value)) {
      return '';
    }
    if (accountBalance == null || accountBalance.length === 0) {
      return '';
    }
    let balances = '';
    accountBalance.forEach((item: ValidationTableFlow) => {
      if (item.before != null && item.before === 0) {
        balances += '0\n';
      } else {
        balances += `${item.before != null ? item.before.toFixed(3) : ''}\n`;
      }
    });
    return balances;
  };

  export const getAccountBalanceAfter = (
    accountBalance: ValidationTableFlow[],
    value: ValidationTableDef,
  ): string => {
    if (isTrade(value)) {
      return '';
    }
    if (accountBalance == null || accountBalance.length === 0) {
      return '';
    }
    let balances = '';
    accountBalance.forEach((item: ValidationTableFlow) => {
      if (item.after != null && item.after === 0) {
        balances += '0\n';
      } else {
        balances += `${item.after != null ? item.after.toFixed(3) : ''}\n`;
      }
    });
    return balances;
  };

  export const getAccountBalanceByExchange = (
    accountBalance: Dictionary<ValidationTableFlow[]> | null,
    value: ValidationTableDef,
  ): string => {
    if (isTrade(value)) {
      return '';
    }
    if (accountBalance == null || accountBalance.length === 0) {
      return '';
    }
    let balances = '';
    for (const [key, item] of Object.entries(accountBalance)) {
      item.forEach((item1: ValidationTableFlow) => {
        if (item1.before != null && item1.before === 0) {
          balances += '0\n';
        } else {
          balances += `${item1.before != null ? item1.before.toFixed(3) : ''}\n`;
        }
      });
    }
    return balances;
  };

  export const getAccountBalanceAfterByExchange = (
    accountBalance: Dictionary<ValidationTableFlow[]> | null,
    value: ValidationTableDef,
  ): string => {
    if (isTrade(value)) {
      return '';
    }
    if (accountBalance == null || accountBalance.length === 0) {
      return '';
    }
    let balances = '';
    for (const [key, item] of Object.entries(accountBalance)) {
      // balances += `${key != null && key != '' ? `${key}:` : ''}\n`;
      item.forEach((item1: ValidationTableFlow) => {
        if (item1.before != null && item1.before === 0) {
          balances += '0\n';
        } else {
          balances += `${item1.after != null ? item1.after.toFixed(3) : ''}\n`;
        }
        // balances += `${item1.after != null ? item1.after.toFixed(3).replace(/[.,]00/, "") : ''} ${item1.coin || ''}\n`;
      });
    }
    return balances;
  };

  // TODO: Generate string server side and remove or move to enum
  export const getTransactionType = (
    typeId: number | null, 
    value: ValidationTableDef,
    allOptions: ValidationSelectOption[],
    ): string => {
    const allArr = allOptions.map((val) => val.value);
    if ((!typeId && typeId !== 0) || !allArr.includes(typeId)) {
      return '';
    }

    let newId = typeId;

    if (isTrade(value)) {
      newId = -1;
    }

    const result = allOptions
      .filter((val) => val.value === newId)
      .map((val) => val.text);

    if (result.length === 1) {
      return result[0];
    }
    return '';
  };


  export const getExchanges = (exchange: string | null, value: ValidationTableDef)
  : ExchangeValue | null => {
    // if trade we take match / possible match to populate
    if (isTrade(value)
    && value.matched_transaction
    && value.matched_transaction.exchange) {
      if (value.matched_transaction.transaction_type === 2) { // withdrawal -> deposit
        return {
          exchange1: value.matched_transaction?.exchange || null,
          exchange2: exchange || null,
        };
      }
      return {
        exchange1: exchange || null,
        exchange2: value.matched_transaction?.exchange || null,
      };
    }
    if (exchange && exchange !== '') {
      return {
        exchange1: exchange,
        exchange2: null,
      };
    }
    return {
      exchange1: null,
      exchange2: null,
    };
  };

  export const getBuy = (
    buy: number | null,
    buyCoin: string | null,
    buyFiat: number | null,
    exchange: string | null,
    value: ValidationTableDef,
  )
  : CoinValue => {
    // if trade we take match / possible match to populate
    if (isTrade(value)
    && buy === 0
    && value.matched_transaction
    && value.matched_transaction.buy
    && value.matched_transaction.buy_coin) {
      if (value.matched_transaction.buy !== 0) {
        return {
          value: value.matched_transaction?.buy || null,
          name: value.matched_transaction?.buy_coin || null,
          fiatValue: (value.matched_transaction?.buy_value_in_fiat && value.matched_transaction?.buy_value_in_fiat !== 0) ? value.matched_transaction?.buy_value_in_fiat : null,
          exchange: value.matched_transaction?.exchange || null,
        };
      } else {
        return {
          value: null,
          name: null,
          fiatValue: null,
          exchange: null,
        };
      }
    }

    //not trade
    if (buy !== 0) {
      return {
        value: buy,
        name: buyCoin,
        fiatValue: buyFiat === 0 ? null : buyFiat,
        exchange,
      };
    }
    return {
      value: null,
      name: null,
      fiatValue: null,
      exchange: null,
    };
  };

  export const getSell = (
    sell: number | null,
    sellCoin: string | null,
    sellFiat: number | null,
    exchange: string | null,
    value: ValidationTableDef,
  )
  : CoinValue => {
    // if trade we take match / possible match to populate
    if (isTrade(value)
    && sell === 0
    && value.matched_transaction
    && value.matched_transaction.sell
    && value.matched_transaction.sell_coin) {
      if (value.matched_transaction.sell !== 0) {
        return {
          value: value.matched_transaction?.sell || null,
          name: value.matched_transaction?.sell_coin || null,
          fiatValue: (value.matched_transaction?.sell_value_in_fiat && value.matched_transaction?.sell_value_in_fiat !== 0) ? value.matched_transaction?.sell_value_in_fiat : null,
          exchange: value.matched_transaction?.exchange || null,
        };
      } else {
        return {
          value: null,
          name: null,
          fiatValue: null,
          exchange: null,
        };
      }
    }
    if (sell !== 0) {
      return {
        value: sell,
        name: sellCoin,
        fiatValue: sellFiat === 0 ? null : sellFiat,
        exchange,
      };
    }
    return {
      value: null,
      name: null,
      fiatValue: null,
      exchange: null,
    };
  };

  export const getGeneralType = (type: number | null | undefined): GeneralTransactionType | undefined => {
    if (!type && type !== 0) {
      return undefined;
    }
    const model = generalTransactionTypes.find(item => item.value === type);
    if (!model && model !== 0) {
      return undefined;
    }
   if (model.in === true && model.out === true) {
      return GeneralTransactionType.TRANSFER;
    }
    if (model.in === true && model.out === false) {
      return GeneralTransactionType.IN;
    }
    if (model.in === false && model.out === true) {
      return GeneralTransactionType.OUT;
    } else {
      return undefined;
    }
};

export const filterAllowedEditTransactionTypes = (type: number | null | undefined, allOptions: ValidationSelectOption[]): ValidationSelectOption[] => {
  const generalType = getGeneralType(type);
  const filtered = allOptions.filter((e) => {
    const generalTypeFilter = getGeneralType(e.value);
    return generalTypeFilter === generalType;
  });
  return filtered;
};

export const handleEditApiCall = (
  ids: string[], 
  valueItem: any,
  onSuccess: () => void,
  onFailure: () => void,
  ) => {
  const formData = axios.toFormData(valueItem);
  ids.forEach(function(i) {
    formData.append("id[]", i)
  });
  postMainAppApiData<any, any>('ajax/validation-report/update.php', formData)
  .then((res: any) => {
    onSuccess();
  }).catch((e) => {
    onFailure();
  });
};

//for api - select
export function getDateStringFromApi(numberValue: number | null): string | null {
  if (!numberValue) return null;
  const date = new Date(numberValue * 1000);
  return getDateString(date);
}
export function getDateString(date: Date | null): string | null {
  if (!date) return null;
  const getYear = date.toLocaleString('default', { year: 'numeric' });
  const getMonth = date.toLocaleString('default', { month: '2-digit' });
  const getDay = date.toLocaleString('default', { day: '2-digit' });
  const dateFormat = `${getYear}-${getMonth}-${getDay}`;
  return dateFormat;
}
export function getHourString(date: Date | null): string | null {
  if (!date) return null;
  const getHour = date.toLocaleString('default', { hour: 'numeric' });
  const getMinute = date.toLocaleString('default', { minute: '2-digit' });
  const dateFormat = `${getHour}:${getMinute}`;
  return dateFormat;
}

export const getDateForUI = (
  numberValue: number | null, 
  dateFormat: string | undefined,
  )
: string | null => {
  if (!numberValue) return null;

  const date = new Date(numberValue * 1000);
  const result = date.toLocaleString?.(dateFormat === 'd.m.Y' ? 'de-DE' : 'en-US', {
    // TODO: Find better way to format
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
  return result;
};

export const getDateForFilter = (
  numberValue: number | null, 
  value: ValidationTableDef,
  )
: Date | null => {
  // if trade we return null
  if (!numberValue || isTrade(value)) {
    return null;
  }
  const date = new Date(numberValue * 1000);
  return date;
};

export const getDateForValidation = (
  numberValue: number | null, 
  dateFormat: string | undefined,
  value: ValidationTableDef | null,
  )
: string | null => {
  // if trade we return null
  if (!numberValue || (value && isTrade(value))) {
    return null;
  }
  const date = new Date(numberValue * 1000);
  const utcDate = dayjs.utc(date);
  const result = utcDate.format(dateFormat === 'd.m.Y' ? 'DD.MM.YYYY HH:mm:ss' : 'MM/DD/YYYY HH:mm:ss');
  return result;
};

export const getRowById = (id: number | null, data: ValidationTableDef[] | undefined): ValidationTableDef | undefined => {
  if (!id && id !== 0) {
    return undefined;
  }
  return (data ?? []).find((item: ValidationTableDef) => item.transaction.id === id);
}

export const getCleanedSubRow = (value: ValidationTableDef): ValidationTableDef => {
  const shallow = { 
    ...value,
    matched_transaction: null,
  }; // make copy

  return shallow;
};

export const getCleanedMatchedTransaction = (value: ValidationTableTransaction): ValidationTableDef => {
  return {
    transaction: value,
    report: null,
    account_balance: null,
    possible_matches: [],
    matched_transaction: null,
    match_result: null,
  };
};

export const getSubRowItems = (row: ValidationTableDef): ValidationTableDef[] | undefined => {
  //has possible matches - show 'match'
  if (row && row.transaction && row.transaction.id && row.possible_matches
  && row.matched_transaction == null
  && !isTrade(row)
  && row.possible_matches
  && row.possible_matches.length > 0) {
  return row.possible_matches
  .flatMap((value: ValidationTableMatchResult, index) => {
    //possible_matches sometimes has info and sometimes has transaction as content
    if (value.info) {
      return value.info;
    } else if (value.transaction) {
      return value;
    } else {
      return undefined;
    }
  });
  //is matched trade - show 'matched' + the 2 items of the trade
  } else if (row && row.transaction && row.transaction.id
  && row.matched_transaction !== null
  && isTrade(row)
  && !isTrade(getCleanedMatchedTransaction(row.matched_transaction))) {
  return [getCleanedSubRow(row), getCleanedMatchedTransaction(row.matched_transaction)];
  //is matched but not a trade - show 'matched' + the other item of the match
} else if (row && row.transaction && row.transaction.id
  && row.matched_transaction !== null
  && !isTrade(row)
  && !isTrade(getCleanedMatchedTransaction(row.matched_transaction))) {
  //in this last case the object we get from api is incomplete, only contains the fields of 'transaction', we set the rest to null
  return [getCleanedMatchedTransaction(row.matched_transaction)];
} else {
  return [];
}
};

export const searchInEnterCoins = async (search: string | null | undefined, onSuccess: () => void, onError: () => void) => {
  const parameter = search ? `?search_tx=${search}` : '';
  try {
    const res = await postMainAppApiData<any, any>('enter_coins.php' + parameter, null);
    onSuccess();
  } catch (e) {
    onError();
  }
};

export const getPossibleMatches = (
  possibleMatches: ValidationTableMatchResult[] | null,
  rowId: number | null,
): MatchElement[] => {
  if (!possibleMatches) {
    return [];
  }
  if (possibleMatches == null || possibleMatches.length === 0) {
    return [];
  }

  if (!rowId || rowId == null) return [];

  const danger: MatchElement[] = [];
  let hasExactMatch = false;

  for (const [key, value] of Object.entries(possibleMatches)) {
    const transactionId: number | undefined = (value.transaction_id as
          number) | (value.transaction?.id as
          number) | undefined;
    if (!transactionId || transactionId == null) {
      continue;
    }
    let color: PillModifier[] = [];
    if (value.match_possibility
      && value.match_possibility >= 90 && !hasExactMatch) {
      color = [PillModifier.GREEN];
      hasExactMatch = true;
    } else {
      color = [PillModifier.BLUE];
    }

    danger.push({ color, rowId, transactionId, coin: value.transaction ? getCoinString(value.transaction) : undefined, transaction_time: value.transaction?.transaction_time || undefined });
  }
  return danger;
};

  export const getCoinString = (transaction: ValidationTableTransaction): string => {
    let coin = transaction.buy_coin;
    if (!coin || coin.length === 0) {
      coin = transaction.sell_coin;
    }
    return coin || "";
  };

export const getSubRowPossibleMatches = (
  possibleMatches: ValidationTableMatchResult[] | null,
  rowId: number | null,
  originalRowId: number | null,
): MatchElement[] => {
  if (!possibleMatches) {
    return [];
  }
  if (possibleMatches == null || possibleMatches.length === 0) {
    return [];
  }

  if (!rowId || rowId == null) return [];

  const danger: MatchElement[] = [];
  let hasExactMatch = false;

  for (const [key, value] of Object.entries(possibleMatches)) {
    const transactionId: number | undefined = (value.transaction_id as
          number) | (value.transaction?.id as
          number) | undefined;
    if (!transactionId || transactionId == null || transactionId !== rowId) {
      continue;
    }
    let color: PillModifier[] = [];
    if (value.match_possibility && value.match_possibility >= 90 && !hasExactMatch) {
      color = [PillModifier.GREEN];
      hasExactMatch = true;
    } else {
      color = [PillModifier.BLUE];
    }

    danger.push({ color, rowId: originalRowId, transactionId, coin: value.transaction ? getCoinString(value.transaction) : undefined, transaction_time: value.transaction?.transaction_time || undefined });
  }
  return danger;
};

export const getNotices = (notifications: Dictionary<boolean>): boolean[] => {
  const errors = [];

  for (const [key, value] of Object.entries(notifications)) {
    if (value) {
      errors.push(true);
    }
  }

  return errors;
};

export const canExpand = (value: ValidationTableDef): boolean => {
  if (value && value.transaction && value.transaction.id) { // is defined
    if ((value.transaction.transaction_type === 2 || value.transaction.transaction_type === 1)
    && (value.transaction.matched_transaction_id == null
    && value.possible_matches?.length > 0
    && value.matched_transaction !== null)
    // is old trade
    ) {
      return true;
    }

    if ((value.possible_matches || []).length > 0) { // has possible match
      return true;
    }

    if (value.transaction.matched_transaction_id !== null && value.matched_transaction !== null) {
      // is already matched
      return true;
    }
  }

  return false;
};

export const getFee = (fee: number | null, feeCoin: string | null, value: ValidationTableDef)
: CoinValue => {
  // if trade we take match / possible match to populate
  if (isTrade(value)
  && fee === 0
  && value.matched_transaction
  && value.matched_transaction.fee
  && value.matched_transaction.fee_coin) {
    return {
      value: value.matched_transaction?.fee || null,
      name: value.matched_transaction?.fee_coin || null,
      fiatValue: null,
      exchange: null,
    };
  }
  if (fee !== 0) {
    return {
      value: fee,
      name: feeCoin,
      fiatValue: null,
      exchange: null,
    };
  }
  return {
    value: null,
    name: null,
    fiatValue: null,
    exchange: null,
  };
};

export const getStringValueForTrade = (stringValue: string | null, value: ValidationTableDef)
: string | null => {
  if (isTrade(value)) {
    return null;
  }
  return stringValue;
};

  export const getRowSelectionIds = (rowSelection: MRT_RowSelectionState): number[] => {
    return Object.keys(rowSelection).map((row, index) => {
      const text = cleanUpTableId(row);
      const convert = Number(text);
      if (Number.isNaN(convert)) {
        console.log("Conversion error" + row);
        return null;
      }
      return convert;
    }).filter(Number);//remove null
  };

  export const cleanUpTableId = (id: string): string | undefined => {
    return id.split(";").find((x) => x.startsWith("id="))?.replace("id=", "");
  };

//In case of duplicate ids the table framework crashes, so we need to also have 
//the index to ensure uniqueness while not redrawing if index + id did not change
export const getRowId = (
  row: ValidationTableDef,
  index: number,
  parentRow: ValidationTableDef | null = null,
  parentIndex: number | null = null,
  ): string => {
    var rowId = `index=${index};`;
    if (row && row.transaction && row.transaction.id) {
      rowId += `id=${row.transaction.id};`
    }
    //handle subrows
    if (parentIndex) {
      rowId += `parentIndex=${parentIndex};`;
    }
    if (parentRow && parentRow.transaction && parentRow.transaction.id) {
      rowId += `parentId=${parentRow.transaction.id};`
    }
    return rowId;
};

 // Warnings
export const hasWarnings = (
  data: TableDataRes<ValidationTableDef, ValidationDetail> | null
): boolean => {
  if (!data) return false;
  if (data.info && data.info.total) {
    return data.info.total.validation_warnings > 0;
  }
  return false;
}

// Duplicates
export const hasDuplicates = (
  data: TableDataRes<ValidationTableDef, ValidationDetail>
): boolean => {
  return data.data.length > 0;
}

export function getTransactionId(tradeHash: string | null, tradeId: string | null): string | null {
    if (tradeHash && tradeHash.length > 0) {
      return tradeHash;
    } else if (tradeId && tradeId.length > 0) {
      return tradeId;
    } else {
      return null;
    }
  }

export const getTimestamp = (date: string | null): number | undefined => {
  if (!date) return undefined;

  const timestamp = new Date(date).getTime() / 1000;
  return timestamp;
}

export const delay = ms => new Promise(res => setTimeout(res, ms));